import React from 'react'
import Header from './Header'
import Footer from './Footer'
import IconEmailSent from "../images/icon-email-sent.png";
import IconEmailOpenRate from "../images/icon-email-open-rate.png"
import IconEmailOpen from "../images/icon-email-open.png"
import IconRepVisit from "../images/icon-representative-visit.png"
import IconIniPackOrder from "../images/icon-inititiation-pack-order.png"
import IconMeth from "../images/icon-methodology.png"
import ImgOurMeth from "../images/img-our-methodology.png"
import IconKeyMet from "../images/icon-keymetrics.png"
import ImgKeyMet from '../images/img-keymetrics.png';

const SamplesComponent = () => {
    return (
        <>
            <Header />{" "}
            <main className="inner-page">
                <section className="container">
                    <div className="row justify-content-center">
                        <div className="width-lg-95 text-center">
                            <h1 className="text-uppercase">DELIVERING REPRESENTATIVE ACCESS AND MEDICAL EDUCATION</h1>
                            <p className="fs-20 lh-sm">Our agile customised omnichannel solution has created ongoing engagement <span className="fw-bold">over two years</span>  with a specialty group (650) <br></br> who are notoriously difficult to access. </p>
                            <div className="spacer-4"></div>
                        </div>
                    </div>
                    <div className="row justify-content-center gx-2">
                        <div className="col-md-6 col-lg-4">
                            <div className="entry-section bg-purple rounded-pill d-flex align-items-center justify-content-center mh-128 mb-4">
                                <div className="entry-icon px-2">
                                    <img src={IconEmailSent} className="img-fluid me-2" alt=""/>
                                </div>
                                <div className="entry-item px-2">
                                    <h2 className="mb-0 fw-bold fs-40 text-white lh-1">5,872</h2>
                                    <p className="mb-0 fs-20 fw-bold text-white lh-1">emails sent</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="entry-section bg-purple rounded-pill d-flex align-items-center justify-content-center mh-128 mb-4">
                                <div className="entry-icon px-2">
                                    <img src={IconEmailOpenRate} className="img-fluid me-2" alt=""/>
                                </div>
                                <div className="entry-item px-2">
                                    <h2 className="mb-0 fw-bold fs-40 text-white lh-1">&gt;60.2%</h2>
                                    <p className="mb-0 fs-20 fw-bold text-white lh-1">email open rate</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="entry-section bg-purple rounded-pill d-flex align-items-center justify-content-center mh-128 mb-4">
                                <div className="entry-icon px-2">
                                    <img src={IconEmailOpen} className="img-fluid me-2" alt=""/>
                                </div>
                                <div className="entry-item px-2">
                                    <h2 className="mb-0 fw-bold fs-40 text-white lh-1">&gt;3,536</h2>
                                    <p className="mb-0 fs-20 fw-bold text-white lh-1">emails opened</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="entry-section bg-purple rounded-pill d-flex align-items-center justify-content-center mh-128 mb-4">
                                <div className="entry-icon px-2">
                                    <img src={IconRepVisit} className="img-fluid me-2" alt=""/>
                                </div>
                                <div className="entry-item px-2">
                                    <h2 className="mb-0 fw-bold fs-40 text-white lh-1">274</h2>
                                    <p className="mb-0 fs-20 fw-bold text-white lh-1">requests for <br></br>representative visits</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="entry-section bg-purple rounded-pill d-flex align-items-center justify-content-center mh-128 mb-4">
                                <div className="entry-icon px-2">
                                    <img src={IconIniPackOrder} className="img-fluid me-2" alt=""/>
                                </div>
                                <div className="entry-item px-2">
                                    <h2 className="mb-0 fw-bold fs-40 text-white lh-1">249</h2>
                                    <p className="mb-0 fs-20 fw-bold text-white lh-1">initiation pack <br></br>orders</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="spacer-11"></div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="testimonial py-5 rounded-5">
                                <div className="row justify-content-center">
                                    <div className="col-10">
                                        <div className="entry-content text-center">
                                            <p className="text-white fs-20 fw-bold fst-italic lh-sm">Solutionary Health exceeded expectations by delivering an exceptional bespoke website that integrated omnichannel features with our CRM and created an effective hub for customer engagement and brand experience. Their solutions-focused mindset, prompt communication, technical expertise and testing rigor enabled the success of the project. I would without hesitation recommend Solutionary Health for their partnership approach, digital capabilities, and vested interest in client success.</p>
                                        </div>
                                        <div className="spacer-1"></div>
                                        <div className="entry-info text-center">
                                            <p className="mb-0 text-white fw-bold lh-sm">Product Manager Top 15 Biopharmaceutical Company</p>
                                            <p className="mb-0 text-white lh-sm">Agile Patient and HCP Custom-Built Omnichannel Hub</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="spacer-11"></div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="entry-section d-flex flex-column flex-lg-row align-items-center align-items-lg-start">
                                <div className="entry-icon">
                                    <img src={IconMeth} className="img-fluid" alt=""/>
                                </div>
                                <div className="entry-content ps-lg-3">
                                    <div className="entry-title text-center text-lg-start mt-3">
                                        <h2 className="fw-bold text-purple lh-sm">Our methodology </h2>
                                        <p className="fs-20 lh-sm">Mapping engagements and communications across the customer journey focused on engineering representative access to leverage brand engagement.  </p>
                                    </div>
                                    <div className="spacer-3"></div>
                                    <div className="entry-image">
                                        <img src={ImgOurMeth} className="img-fluid" alt=""/>
                                    </div>
                                </div>
                            </div>
                            <hr className="border-2 my-5" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="entry-section d-flex flex-column flex-lg-row align-items-center align-items-lg-start">
                                <div className="entry-icon">
                                    <img src={IconKeyMet} className="img-fluid" alt=""/>
                                </div>
                                <div className="entry-content ps-lg-3">
                                    <div className="entry-title text-center text-lg-start mt-3">
                                        <h2 className="fw-bold text-purple lh-sm">Key metrics power our omnichannel solutions </h2>
                                    </div>
                                    <div className="spacer-3"></div>
                                    <div className="entry-image webiste-campaign">
                                        <img src={ImgKeyMet} className="img-fluid" alt=""/>
                                    </div>
                                </div>
                            </div>
                            <div className="spacer-5"></div>
                        </div>
                    </div>
                    <div className="spacer-11"></div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="testimonial py-5 rounded-5">
                                <div className="row justify-content-center">
                                    <div className="col-10">
                                        <div className="entry-content text-center">
                                            <p className="text-white fs-20 fw-bold fst-italic lh-sm">Solutionary Health has honestly created a best-practice product and provided services that have made me look like a high achiever in my company… 100% would recommend.</p>
                                        </div>
                                        <div className="spacer-1"></div>
                                        <div className="entry-info text-center">
                                            <p className="mb-0 text-white fw-bold lh-sm">Product Manager Top 15 Biopharmaceutical Company</p>
                                            <p className="mb-0 text-white lh-sm">Standards of Excellence</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="spacer-11"></div>
                </section>
            </main>

            <Footer />
        </>
    )
}

export default SamplesComponent